// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__36kl-","header":"ClearentDisclaimer_header__16TUx","inner":"ClearentDisclaimer_inner__H6M2X"};